import React from "react";
import ReactTable from "react-table";
import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import {Card, CardContent} from "@material-ui/core";
import {Link} from "react-router-dom";

class TransactionRefunds extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Transactions_Refunds._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 5;
		this.limit = 5;
	}

	componentDidMount() {
		this.fetchData().then();
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		let user = this.props.rootState.name;

		const columns = [
			{
				Header: "Name",
				id: "item",
				accessor: (r) => {
					if (r.service && r.transaction_services) {
						return r.transaction_services.name;
					}
					if (r.item && r.transaction_items) {
						return r.transaction_items.name;
					}
					if (r.consignment && r.transaction_consignments) {
						return r.transaction_consignments.name;
					}
					if (r.product && r.transaction_products) {
						return r.transaction_products.name;
					}
					return "";
				},
			},
			{
				Header: "Quantity",
				id: "quantity",
				className: 'center-column',
				accessor: r => r.quantity,
			},
			{
				Header: "Refund Amount",
				id: "amount",
				className: 'right-column',
				accessor: r => r.amount,
			},
			{
				Header: "Restocking Fee",
				id: "amount",
				className: 'right-column',
				accessor: r => r.restocking_fee ? r.restocking_fee : "0.00",
			},
			{
				Header: "Date",
				id: "created",
				className: 'center-column',
				accessor: r => {
					return moment(r.created).local().format("MM/DD/YYYY hh:mm A")
				}
			},
			{
				Header: "User",
				id: "user",
				/** @var r.users */
				accessor: r => r.users != null ? (r.users.name_first + " " + r.users.name_last) : this.props.rootState.account_name,
				Cell: props => props.original.users != null ?
					<Link to={"/users/" + props.original.users.pkey}>{props.value}</Link> :
					<Link to={"/settings"}>{this.props.rootState.account_name}</Link>
			},
			{
				Header: "Method",
				id: "method",
				className: 'center-column',
				accessor: r => r.method,
			},
			{
				Header: "Note",
				id: "note",
				accessor: r => r.note,
			},

		];

		return (
			<>
				{data.length > 0 &&
					<Card>
						<CardContent>
							<div className="box-body">
								<div className="table-bar">
									<div className="d-flex">
										{this.renderHeaderRight("Transaction Items", columns)}
									</div>
								</div>
								<ReactTable
									key={this.state.key}
									columns={columns}
									manual // Forces table not to paginate or sort automatically, so we can handle it server-side
									data={data}
									pages={pages} // Display the total number of pages
									loading={loading} // Display the loading overlay when we need it
									loadingText="Requesting Data"
									onFetchData={this.fetchData} // Request new data when things change
									onPageSizeChange={this.onPageSizeChange}
									onSortedChange={this.onSortedChange}
									page={this.state.page}
									onPageChange={this.onPageChange}
									expanderDefaults={{
										sortable: true,
										resizable: true,
										filterable: false,
										width: undefined
									}}
									onExpandedChange={this.onExpandedChange}
									defaultSorted={[
										{
											id: this.model.sort,
											desc: this.model.order === 'desc'
										}
									]}
									showPagination={true}
									showPaginationTop={false}
									showPaginationBottom={true}
									showPageSizeOptions={true}
									defaultPageSize={limit}
									pageSize={limit}
									pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
									className="-striped -highlight"
								/>
							</div>
							{APPCONFIG.settings.isDev() ? null :
								<Framework.Elements.LoadingSpinner isLoading={loading}/>
							}
						</CardContent>
					</Card>}
			</>
		)
	}
}

export default Framework.Components.withRootState(TransactionRefunds);
